(() => {
  console.log("GLOBAL VEHICLE FILTER");
  function applyFilter() {
    const wrapper = document.querySelector(".section-vehicle-filter--wrapper");
    const loadingIcon = document.querySelector(
      ".section-vehicle-filter--wrapper .loading-icon"
    );
    if (!wrapper) return;
    const showLoadingIcon = () => {
      if (loadingIcon) loadingIcon.classList.add("visible");
    };

    const hideLoadingIcon = () => {
      if (loadingIcon) loadingIcon.classList.remove("visible");
    };

    const updateVehicleTitles = (vehicleName) => {
      document.querySelectorAll("[data-global-vehicle-title]").forEach((el) => {
        el.textContent = vehicleName;
      });
    };

    const applyVehicleFilter = (filter) => {
      wrapper.classList.remove("empty-filter");
      const searchParams = new URLSearchParams(window.location.search);

      if (
        filter.vehicleCollectionHandle != "" &&
        window.location.pathname.includes(filter.vehicleCollectionHandle)
      ) {
        hideLoadingIcon();
        return;
      }

      if (searchParams.has("filter.p.m.organizer.car_models")) {
        const param = decodeURIComponent(
          searchParams.get("filter.p.m.organizer.car_models")
        );
        if (param === filter.vehicleName) {
          hideLoadingIcon();
          return;
        }
      }
      const shouldForce = document
        .querySelector("#global-vehicle-filter")
        .dataset.productType.includes("wheels");
      if (window.location.pathname.includes("collections") || shouldForce) {
        searchParams.set("filter.p.m.organizer.car_models", filter.vehicleName);
        window.location.search = searchParams.toString();
      }
    };
    try {
      showLoadingIcon();
      const hasFilter = localStorage.getItem("gta-global-vehicle-filter");
      if (hasFilter) {
        if (Shopify.globalVehicleFilter.vehicle_page) {
          hideLoadingIcon();
          return;
        }
        const filter = JSON.parse(hasFilter);
        updateVehicleTitles(filter.vehicleName);
        applyVehicleFilter(filter);
      } else {
        wrapper.classList.remove("closed");
      }
      hideLoadingIcon();
    } catch (e) {
      console.error(e);
    } finally {
    }
  }

  function setFilter(vehicle, autoApply = true) {
    localStorage.setItem("gta-global-vehicle-filter", JSON.stringify(vehicle));
    if (autoApply) applyFilter();
  }

  function variantHandler() {
    if (Shopify.globalVehicleFilter.page_type !== "product") return;
    const filter = localStorage.getItem("gta-global-vehicle-filter");
    const isWheelProduct = document.querySelector("#is-wheel-product");
    if (filter && isWheelProduct) {
      console.log("APPLYING VARIANT FILTER");
      const vehicle = JSON.parse(filter).vehicleName;
      const select = document
        .querySelector("[data-variant-filter-vehicles]")
        .closest("select");
      const variantOptions = document.querySelectorAll(
        "[data-variant-filter-vehicles]"
      );
      if (!variantOptions) return;
      let firstVisibleOption = null;
      variantOptions.forEach((option) => {
        if (!option.dataset.variantFilterVehicles.includes(vehicle)) {
          option.style.display = "none";
        } else if (!firstVisibleOption) {
          firstVisibleOption = option;
        }
      });
      if (firstVisibleOption) {
        firstVisibleOption.selected = true;
      }
      const small = document.createElement("small");
      small.textContent = "*Results are filtered by your vehicle selection";
      small.style.display = "block";
      small.style.color = "#6c757d";
      small.style.fontSize = "10px";
      small.style.marginTop = "5px";
      select.parentElement.parentElement.appendChild(small);
    }
  }

  window.globalVehicleFilter = {
    setFilter,
    applyFilter,
    variantHandler,
    clearFilter: () => {
      localStorage.removeItem("gta-global-vehicle-filter");
      applyFilter();
    },
  };
  applyFilter();
  window.addEventListener("DOMContentLoaded", variantHandler);
})();
